import "@/App.css";
import SkyHop from "@/SkyHop";

function App() {
  return (
    <div className="App">
      <SkyHop />
    </div>
  );
}

export default App;
